module.exports = __webpack_public_path__ + "static/media/card_brand_vr.05a8a69d.svg";